import React from 'react';

const SharedDragGrip = ({
  active = true,
  disabled = false,
  title = 'Drag to move',
  className = '',
  size = 'md',
}) => {
  const sizeClass = size === 'sm' ? 'p-0.5' : 'p-1.5';
  const iconClass = size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
  const stateClass = disabled
    ? 'bg-gray-500 text-white cursor-not-allowed ring-1 ring-gray-400/60'
    : active
      ? 'bg-primary-600 text-white cursor-grab active:cursor-grabbing shadow-md ring-2 ring-primary-300/70'
      : 'bg-gray-500 text-white cursor-not-allowed';

  return (
    <div
      data-shared-drag-grip
      className={`inline-flex items-center justify-center rounded-md ${sizeClass} ${stateClass} ${className}`}
      title={title}
      aria-label={title}
      aria-hidden={disabled ? undefined : false}
    >
      <svg className={iconClass} fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M7 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM7 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM7 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM13 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM13 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM13 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
      </svg>
    </div>
  );
};

export default SharedDragGrip;
